export default {
  title: 'schema.medicalExamination.medicalExamination',
  type: 'object',
  properties: {
    name: {
      title: 'schema.medicalExamination.name',
      type: 'string',
      fieldRequired: true
    },
    description: {
      title: 'schema.medicalExamination.description',
      type: 'string',
      fieldRequired: false
    },
    profileId: {
      type: 'number',
      fieldRequired: true
    },
    teamId: {
      type: 'number',
      fieldRequired: true
    },
    end: {
      title: 'schema.medicalExamination.end',
      type: 'string',
      format: 'date',
      fieldRequired: true
    }
  }
};
